import React, { useEffect, useState } from 'react';
import { useShoppingCart } from '../hooks/useShoppingCart';
import ProductList from '../components/ProductList';

const Addons = ({products}) => {
    const {interval} = useShoppingCart()
    return (
        <div>
            <ProductList products={products} category={'addon'} selectedInterval={interval}/>
        </div>
    )
}

export default Addons;